module.exports = __webpack_public_path__ + "static/media/TeamViewerQS_es.7058ab6c.exe";